<template>
  <div class="grid-container full container">
    <div class="grid-x" >
      <div class=" small-12 medium-6 cell text-center hide-for-small-only left-column page-contents-8-left">
        <div class="video-trigger">
          <img src="../../../assets/img/hemisphereImages/vimeo.png" @click="openVimeoModal"
               alt="Hemisphere video thumbnail" />
        </div>
      </div>
      <div class="small-12 medium-6 cell text-left small-text-center page-contents-8-right right-column">
        <h1 v-if="isHeader">Hemisphere</h1>
        <h2 v-else>Hemisphere</h2>

        <p class="tag">Combat bias. Reprogramme your brain. Make better decisions.</p>

        <rare-standard-button
          class="contactButton show-for-small-only"
          :tabIndex="12"
          :active="'true'"
          :buttonText="buttonLabel"
          :height="'40px'"
          :width="'200px'"
          :fontColor="'#ffffff'"
          :fontSize="'14px'"
          @clicked="handleButtonClick()"
        />
        <rare-standard-button
          class="contactButton show-for-medium"
          :tabIndex="12"
          :active="'true'"
          :buttonText="buttonLabel"
          :height="'75px'"
          :width="'316px'"
          :fontColor="'#ffffff'"
          :fontSize="'20px'"
          @clicked="handleButtonClick()"
        />

      </div>
      <div class="show-for-small-only mobile-video">
        <iframe src="https://player.vimeo.com/video/536392149" allow="autoplay; fullscreen" allowfullscreen="allowfullscreen"></iframe>
      </div>
    </div>

    <!-- VIMEO MODAL -->
    <div v-if="vimeoModalOpen" id="thanksModal" @click="closeVimeoModal">
      <div id="thanksInner">
        <div class="vimeo-close">
          <rare-modal-close-icon-large
            class="rareModalCloseIcon"
            @clicked="closeVimeoModal"
          />
        </div>
        <div class="vimeo-video">
           <iframe id="video" :src="vimeoLink" allow="autoplay; fullscreen"  allowfullscreen="allowfullscreen"></iframe>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import RareStandardButton from '@/components/atoms/RareWebButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLargeBlack';

export default {
  name: 'RareHomeProductsHemisphere',
  props: {
    isHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      buttonLabel: '',
      vimeoModalOpen: false,
      vimeoLink: null,
    };
  },
  components: {
    'rare-standard-button': RareStandardButton,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
  },
  mounted() {
    this.buttonLabel = this.isHeader === true ? 'Get in touch' : 'Learn more';
  },
  methods: {
    handleButtonClick() {
      if (this.isHeader) {
        this.$emit('jumpToForm');
      } else {
        this.$router.push('/products/hemisphere');
      }
    },
    openVimeoModal() {
      this.vimeoModalOpen = true;
      this.vimeoLink = 'https://player.vimeo.com/video/536392149?autoplay=1&autopause=0';
    },
    closeVimeoModal() {
      this.vimeoModalOpen = false;
      this.vimeoLink = null;
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  iframe { border: none; width: 100%; height: 100%; }

  .container {
    border-bottom: 1px solid $border;
  }

  p.tag {
    color: $main-text;
  }

  h2, h1 {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  @media only screen and (max-width: 640px) {

    .full {
      background-image: none;
      margin-top: 0;
    }

    .page-contents-8-left {
      padding: 0 5% !important;
    }

    .page-contents-8-right {
      padding: 0 5% !important;
    }

    .left-column {
      padding: 0 8.6% !important;
    }

    .tag {
      text-align: center;
      font-size: 20px;
      line-height: 30px;
    }

    h2, h1 {
      font-size: 28px;
      line-height: 1.43;
      margin: 28px 0 18px 0;
      text-align: center;
    }

    .contactButton {
      margin: 25px auto 20px auto;
    }

    .mobile-video {
      width: 100%;
      height: 250px;
      margin-bottom: 54px;
      margin-top: 20px;
    }
  }

  @media only screen and (min-width: 641px) {

    .right-column {
      padding-left: 80px !important;
    }

    .tag {
      font-size: 30px;
    }

    h2, h1 {
      font-size: 56px;
      line-height: 1.29;
      margin: 133px 0 33px 0;
      text-align: left;
    }

    .contactButton {
      margin: 47px 0 160px 0;
    }

  }

  .video-trigger {
    height: 100%;
    padding-right: 50px;
  }

  .video-trigger img {
    margin-top: 148px;
    cursor: pointer;
  }

  #thanksModal {
    display: flex;
    position: fixed;
    z-index: 99999;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  #thanksInner {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    width: 80%;
    height: 90%;
    background-color: white;
    text-align: left;
    padding: 0 10px 0 10px;
  }

  .vimeo-close {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .vimeo-close div {
    cursor: pointer;
  }

  .vimeo-video {
    height: 100%;
    width: 100%;
    // margin-bottom: 10px;
  }

  .rareModalCloseIcon {

  }

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/components/RareHomeProductsHemisphere.vue